import { motion } from "framer-motion";

export default function ProgressThread({ current, total }) {
  const progress = ((current + 1) / total) * 100;
  
  return (
    <div className="brief-progress-thread">
      <motion.div 
        className="brief-progress-line"
        initial={{ width: 0 }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      >
        <div className="brief-progress-node" />
      </motion.div>
    </div>
  );
}
